import React, { PropsWithChildren } from "react"
import { SxProps, Theme, Typography } from "@mui/material"

export type PrimitiveTextProps = PropsWithChildren<{
	variant?: "body1" | "body2" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "button" | "caption" | "inherit" | "overline" | "subtitle1" | "subtitle2"
	textTransform?: "capitalize" | "uppercase" | "lowercase" | "none"
	gutterBottom?: boolean
	sx?: SxProps<Theme>
}>

export const PrimitiveText = ({
	children,
	variant,
	textTransform,
	...props
}: PrimitiveTextProps) => {
	return <Typography
		variant={variant}
		textTransform={textTransform}
		{...props}
	>
		{children}
	</Typography>
}
